export default __webpack_public_path__ + "static/jet-a5fba3151bd9a8cb6f41699f87187295.mp4";